webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(215)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(1145),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(212)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(1142),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4aa0d29e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1110:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(219)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(1150),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f7cec41e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1111:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(207)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(1137),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b4785ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1112:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(1148),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-875e025a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1113:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(214)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(1144),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73c26217",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1114:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(204)
}
var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(1134),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1dcbb3a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1115:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(203)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(1133),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17dfdf9c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(206)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(1136),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21d810e9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1117:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(199)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(1129),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-051c3e5a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1118:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(218)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(1149),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f24a29aa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1119:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(213)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(1143),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6dd3e87c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1120:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(1147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1121:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(200)
}
var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(1130),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0e4e1842",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1122:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(208)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(1138),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f807c34",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1123:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(209)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(1139),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-43f37a2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1124:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(211)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(1141),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44f1e148",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1125:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(210)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(1140),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-43fd7a93",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(1146),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1127:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(1132),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1618b81e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1128:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(201)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(1131),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0fd34010",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1129:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-header is-medium bottom-align",
    class: {
      'is-center': !_vm.top, 'is-center-top': _vm.top
    },
    style: ({
      background: ("url(" + (this.backgroundImage) + ")")
    })
  }, [_c('div', {
    staticClass: "category container "
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "is-white m-b-5 title",
    class: _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet) ? 'is-2' : 'is-4'
  }, [_vm._v(_vm._s(_vm.content))])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1130:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "has-gradient-background"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns is-9 is-variable"
  }, [_c('div', {
    staticClass: "column is-vcentered"
  }, [_c('p', {
    staticClass: "subtitle is-white is-6 is-fullwidth",
    class: {
      'has-text-centered': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet)
    }
  }, [_vm._v("2019 ATD All Copyrights Reserved.")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('figure', {
    staticClass: "image",
    class: _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet) ? 'is-pulled-right' : 'is-centered'
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/fstatic/logo.svg",
      "alt": ""
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1131:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('bread-crumb', {
    attrs: {
      "routeName": 'Solutions',
      "subRoute": _vm.solution_name
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('hero', {
    attrs: {
      "backgroundImage": _vm.slide_image,
      "content": _vm.slide_label
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "has-primary-background section"
  }, [_c('p', {
    staticClass: "subtitle is-5 is-white content",
    domProps: {
      "innerHTML": _vm._s(_vm.solution_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [(_vm.case_study) ? _c('div', {
    staticClass: "column is-6"
  }, [_c('a', {
    staticClass: "m-b-50 is-red title is-4 is-hoverable",
    attrs: {
      "href": ("https://" + (this.baseURL()) + "/" + _vm.case_study_pdf),
      "download": ""
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-right"
    }
  }), _vm._v(" Download case study\n          ")], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless"
  }, _vm._l((_vm.related), function(solution, index) {
    return _c('div', {
      staticClass: "column",
      class: {
        'm-r-10': index < 2 && _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet),
          'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet),
      }
    }, [_c('card', {
      attrs: {
        "to": ("solutions/" + (solution.solution_name)),
        "red": true,
        "background": ("https://" + (_vm.baseURL()) + "/" + (solution.slide_image.path)),
        "subtitle": solution.slide_label,
        "title": solution.solution_name,
        "height": "40vh"
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1132:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('landing'), _vm._v(" "), _c('home-cards')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1133:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$mq.resize && _vm.$mq.above('500px')) ? _c('div', {
    staticClass: "has-gradient-background"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section flex"
  }, [_c('p', {
    staticClass: "is-white subtitle no-margin-bottom is-6 m-l-auto"
  }, [_vm._v("Home "), _c('icon', {
    attrs: {
      "scale": "0.8",
      "name": "chevron-right"
    }
  }), _vm._v(" " + _vm._s(_vm.routeName) + " "), (_vm.subRoute) ? _c('span', [_c('icon', {
    attrs: {
      "scale": "0.8",
      "name": "chevron-right"
    }
  }), _vm._v(" " + _vm._s(_vm.subRoute))], 1) : _vm._e()], 1)])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1134:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thumb relative"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1135:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      ltr: _vm.$store.getters.locale == 'en', rtl: _vm.$store.getters.locale == 'ar'
    },
    attrs: {
      "id": "app"
    }
  }, [_c('base-layout')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1136:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative",
    on: {
      "mouseover": function($event) {
        _vm.hovered(true)
      },
      "mouseleave": function($event) {
        _vm.hovered(false)
      },
      "click": function($event) {
        _vm.route(_vm.to)
      }
    }
  }, [_c('div', {
    ref: "parent",
    staticClass: " rectangle m-b-10 is-hoverable",
    class: {
      colored: _vm.isHovered, 'is-center': !_vm.top, 'is-top': _vm.top
    },
    style: ({
      background: ("url(" + (this.background) + ")"),
      'min-height': _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet) ? _vm.height : '50vh',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "absolute content-style is-hoverable",
    class: {
      hide: _vm.isHovered || _vm.isClicked, contact: _vm.$route.name === 'contact'
    },
    on: {
      "click": function($event) {
        _vm.route(_vm.to)
      }
    }
  }, [(_vm.$route.name === 'contact' && !_vm.isClicked) ? _c('h2', {
    staticClass: "title is-2 is-capitalized no-margin-bottom",
    class: _vm.red ? 'is-red' : 'is-white',
    on: {
      "click": function($event) {
        _vm.isClicked = !_vm.isClicked
      }
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'contact') ? _c('h2', {
    staticClass: "title is-2 is-capitalized no-margin-bottom",
    class: _vm.red ? 'is-red' : 'is-white'
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet) && !_vm.html) ? _c('h3', {
    staticClass: "subtitle no-margin-top is-white is-5 "
  }, [_vm._v(_vm._s(_vm.subtitle) + "\n\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet) && _vm.html) ? _c('h3', {
    staticClass: "subtitle is-white is-5 no-margin-top relative",
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isClicked && _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet) && _vm.$route.name === 'contact') ? _c('div', {
    staticClass: "is-white is-5 no-margin-top relative",
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    },
    on: {
      "click": function($event) {
        _vm.isClicked = !_vm.isClicked
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.$route.name !== 'contact') ? _c('button', {
    staticClass: "is-bold is-white has-gradient-background button",
    on: {
      "click": function($event) {
        _vm.route(_vm.to)
      },
      "mouseover": function($event) {
        _vm.isHovered = true
      },
      "mouseleave": function($event) {
        _vm.isHovered = false
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-right"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1137:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown",
    class: {
      'is-active is-active-menu': _vm.isActive
    },
    on: {
      "mouseover": _vm.Fn,
      "mouseleave": function($event) {
        _vm.isActive = false
      }
    }
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('div', {
    attrs: {
      "aria-haspopup": "true",
      "aria-controls": "dropdown-menu"
    }
  }, [_c('a', {
    staticClass: "is-capitalized menu",
    attrs: {
      "href": "#"
    },
    nativeOn: {
      "mouseover": function($event) {
        return _vm.revealDropdown($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.route) + "\n      ")])])]), _vm._v(" "), _c('div', {
    ref: "dropdown",
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('div', {
    staticClass: "flex has-primary-background menu-content"
  }, [_vm._l((_vm.itemsObj), function(list) {
    return (_vm.solutions) ? _c('div', [_c('p', {
      staticClass: "is-bold is-white dropdown-item is-active category"
    }, [_vm._v(_vm._s(list[0].value))]), _vm._v(" "), _vm._l((list), function(item, index) {
      return (index > 0) ? _c('router-link', {
        staticClass: "is-white dropdown-item is-active is-hoverable",
        attrs: {
          "to": ("/" + _vm.route + "/" + (item.value))
        }
      }, [_vm._v("\n            " + _vm._s(item.value.replace(/-/g, " ")) + "\n          ")]) : _vm._e()
    })], 2) : _vm._e()
  }), _vm._v(" "), (_vm.capabilities) ? _c('div', _vm._l((_vm.itemsObj), function(item, index) {
    return _c('div', [_c('router-link', {
      staticClass: "is-white dropdown-item is-active is-hoverable",
      attrs: {
        "to": ("/" + _vm.route + "/" + (item.value))
      }
    }, [_vm._v("\n              " + _vm._s(item.value.replace(/-/g, " ")) + "\n            ")])], 1)
  })) : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1138:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    ref: "navbar",
    staticClass: "navbar has-primary-background"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": '/'
    }
  }, [_c('figure', {
    staticClass: "image relative"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/fstatic/logo-text.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "absolute rotate",
    attrs: {
      "src": "/fstatic/spinner.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger burger",
    attrs: {
      "data-target": "navMenubd-example"
    },
    on: {
      "click": function($event) {
        _vm.menuIsActive = !_vm.menuIsActive
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), (_vm.menuIsActive) ? _c('div', [_c('mobile-navbar', {
    attrs: {
      "solutions": _vm.allSolutions,
      "capabilities": _vm.capabilities
    },
    on: {
      "clicked": function($event) {
        _vm.menuIsActive = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu has-primary-background",
    attrs: {
      "id": "navMenubd-example"
    }
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('ul', [_c('li', {
    class: {
      'is-red': _vm.$route.path === '/'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("navbar.home")) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-red': _vm.$route.path === '/about'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/about'
    }
  }, [_vm._v(" About Us ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-red': _vm.$route.name === 'capabilities'
    }
  }, [_c('dropdown', {
    attrs: {
      "route": "capabilities",
      "capabilities": true,
      "itemsObj": _vm.capabilities
    }
  })], 1), _vm._v(" "), _c('li', {
    class: {
      'is-red': _vm.$route.name === 'solutions'
    }
  }, [_c('dropdown', {
    attrs: {
      "route": "solutions",
      "solutions": true,
      "itemsObj": _vm.solutions
    }
  })], 1), _vm._v(" "), _c('li', {
    class: {
      'is-red': _vm.$route.path === '/careers'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/careers'
    }
  }, [_vm._v(" Careers ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-red': _vm.$route.path === '/contact'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/contact'
    }
  }, [_vm._v(" Contact Us ")])], 1)])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1139:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('bread-crumb', {
    attrs: {
      "routeName": 'About Us'
    }
  }), _vm._v(" "), _c('hero', {
    attrs: {
      "backgroundImage": _vm.slide_image + '',
      "content": _vm.slide_label
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "has-primary-background section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4",
    class: {
      'm-b-50': _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)
    }
  }, [_c('h2', {
    staticClass: "title is-red is-3"
  }, [_vm._v("\n            " + _vm._s(_vm.mission_label) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "subtitle is-white is-5"
  }, [_vm._v("\n            " + _vm._s(_vm.mission) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-variable is-9"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('h2', {
    staticClass: "title is-red is-3"
  }, [_vm._v("\n            " + _vm._s(_vm.our_services_label) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('ul', _vm._l((_vm.our_services), function(service) {
    return _c('li', {
      staticClass: "subtitle is-white is-5 m-b-5 m-t-5"
    }, [_vm._v("\n              " + _vm._s(service.value) + "\n            ")])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-image",
    style: ({
      background: _vm.middle_image
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "has-white-background"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "has-white-background section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n              " + _vm._s(_vm.our_customers) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-paddingless is-marginless is-gapless is-mobile"
  }, [_c('div', {
    staticClass: "column flex is-vertically-centered"
  }, [_c('icon', {
    staticClass: "is-hoverable",
    class: {
      gray: false
    },
    attrs: {
      "scale": "2",
      "name": "chevron-left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prev($event)
      }
    }
  })], 1), _vm._v(" "), _c('carousel', {
    ref: "carousel",
    staticClass: "column is-10",
    attrs: {
      "navigationNextLabel": ">",
      "navigationPrevLabel": "<",
      "navigationEnabled": false,
      "paginationEnabled": false,
      "per-page": 2,
      "perPageCustom": [
        [770, 4]
      ],
      "navigateTo": 0,
      "paginationSize": 15,
      "paginationActiveColor": 'white',
      "paginationColor": 'gray'
    }
  }, _vm._l((_vm.customers), function(customer) {
    return _c('slide', [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "customer-image",
      attrs: {
        "src": ("https://" + (_vm.baseURL()) + (customer.value.path)),
        "alt": customer.value.title,
        "title": customer.value.title
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "column flex is-vertically-centered"
  }, [_c('icon', {
    staticClass: "is-hoverable",
    class: {
      gray: false
    },
    attrs: {
      "scale": "2",
      "name": "chevron-right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.next($event)
      }
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "has-primary-background section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('h2', {
    staticClass: "title is-red is-3"
  }, [_vm._v("\n            " + _vm._s(_vm.letter_label) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "subtitle is-white is-5 m-b-15",
    domProps: {
      "innerHTML": _vm._s(_vm.letter)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title m-b-5 m-t-15 is-white is-4"
  }, [_vm._v("\n            " + _vm._s(_vm.letter_signature) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "title m-t-5 is-red is-5"
  }, [_vm._v("Chief Excutive Officer")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-4"
  }, [_c('h2', {
    staticClass: "title is-red is-3"
  }, [_vm._v("Our Customers")])])
}]}

/***/ }),

/***/ 1140:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('bread-crumb', {
    attrs: {
      "routeName": 'Careers'
    }
  }), _vm._v(" "), _c('hero', {
    attrs: {
      "backgroundImage": _vm.slide_image,
      "content": _vm.slider_text,
      "top": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('p', {
    staticClass: "is-white subtitle is-5 m-b-50",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns m-b-10 is-multiline"
  }, _vm._l((_vm.careers), function(career) {
    return _c('div', {
      staticClass: "column is-6"
    }, [_c('ul', [_c('li', {
      staticClass: "is-white subtitle is-bold is-5"
    }, [_vm._v(_vm._s(career.value))])])])
  }))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1141:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('bread-crumb', {
    attrs: {
      "routeName": 'Capabilities',
      "subRoute": _vm.capability_name
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('hero', {
    attrs: {
      "backgroundImage": _vm.slider_image,
      "content": _vm.slider_label
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "is-white subtitle is-5 content",
    domProps: {
      "innerHTML": _vm._s(_vm.header)
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.bullet_points), function(point) {
    return _c('li', {
      staticClass: "is-block is-white title is-bold is-5"
    }, [_vm._v("\n          " + _vm._s(point.value) + "\n        ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless"
  }, _vm._l((_vm.related), function(capability, index) {
    return _c('div', {
      staticClass: "column",
      class: {
        'm-r-10': index < 2 && _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet),
          'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet),
      }
    }, [_c('card', {
      attrs: {
        "to": ("capabilities/" + (capability.capability_name)),
        "red": true,
        "background": ("https://" + (_vm.baseURL()) + "/" + (capability.slider_image.path)),
        "subtitle": capability.slider_text,
        "title": capability.capability_name,
        "height": "40vh"
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1142:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isLoading) ? _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns m-b-10 m-t-10 is-gapless"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-7",
    class: {
      'm-r-10': _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet),
        'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet),
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "isButtonHiddenMobile": true,
      "subtitle": _vm.solutions,
      "background": _vm.solutions_image,
      "title": 'solutions',
      "to": ("solutions/" + _vm.solutionsInitialRoute),
      "height": "70vh"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns is-marginless is-gapless flex-column"
  }, [_c('div', {
    staticClass: "column m-b-10",
    class: {
      'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet)
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "isButtonHiddenMobile": true,
      "subtitle": _vm.about,
      "background": _vm.about_image,
      "title": 'about us',
      "to": "about",
      "height": "calc(35vh - 5px)"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column",
    class: {
      'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet)
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "isButtonHiddenMobile": true,
      "subtitle": _vm.capabilities,
      "background": _vm.capabilities_image,
      "title": 'capabilities',
      "to": ("capabilities/" + _vm.capabilitiesInitialRoute),
      "height": "calc(35vh - 5px)"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-marginless is-gapless"
  }, [_c('div', {
    staticClass: "column is-5",
    class: {
      'm-r-10': _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet),
        'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet),
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "isButtonHiddenMobile": true,
      "subtitle": _vm.contact,
      "background": _vm.contact_image,
      "title": 'contact us',
      "to": "contact",
      "height": "70vh"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column m-b-10",
    class: {
      'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet)
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "isButtonHiddenMobile": true,
      "top": true,
      "subtitle": _vm.careers,
      "background": _vm.careers_image,
      "title": 'careers',
      "to": "careers",
      "height": "70vh"
    }
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vanish"
  }, [_c('p', [_vm._v("Lorem, ipsum dolor.")])])
}]}

/***/ }),

/***/ 1143:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "relative"
  }, _vm._l((_vm.result), function(item, index) {
    return _c('div', {
      staticClass: "relative"
    }, [_vm._l((item), function(x) {
      return [_c('div', {
        staticClass: "flex"
      }, [(x.field.label === 'Category') ? _c('h1', {
        staticClass: "title is-4 is-white",
        class: {
          'm-b-15': true
        }
      }, [_vm._v("\n                        " + _vm._s(x.value) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
        class: {
          'toggle': !_vm.expand
        }
      }, [(x.field.label === 'Subcategory') ? _c('h2', {
        staticClass: "title is-5 is-white"
      }, [_c('router-link', {
        attrs: {
          "to": ("/solutions/" + (x.value))
        }
      }, [_c('img', {
        staticClass: "img",
        attrs: {
          "src": "/fstatic/spinner.svg"
        }
      }), _vm._v(" " + _vm._s(x.value) + "\n                        ")])], 1) : _vm._e()])]
    })], 2)
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 1144:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('router-link', {
    staticClass: "title is-5 is-white m-t-50",
    attrs: {
      "to": '/'
    }
  }, [_vm._v("Return to "), _c('span', {
    staticClass: "is-underlined"
  }, [_vm._v("Homepage")]), _vm._v("? ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "title is-1 is-white"
  }, [_vm._v("404")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "title is-1 is-white"
  }, [_vm._v("PAGE NOT FOUND :(")])])
}]}

/***/ }),

/***/ 1145:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
    return _c('path', _vm._b({
      key: ("path-" + i)
    }, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
    return _c('polygon', _vm._b({
      key: ("polygon-" + i)
    }, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1146:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('bread-crumb', {
    attrs: {
      "routeName": 'Contact'
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('loading') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-marginless is-paddingless is-gapless"
  }, [_c('div', {
    staticClass: "column is-7 m-b-10",
    class: {
      'm-r-10': _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "background": _vm.egypt_image,
      "isButtonHidden": true,
      "html": true,
      "email": _vm.egypt_email,
      "subtitle": _vm.egypt,
      "title": "EGYPT",
      "height": "70vh"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-5 m-b-10"
  }, [_c('card', {
    attrs: {
      "red": true,
      "background": _vm.UAE_image,
      "isButtonHidden": true,
      "html": true,
      "email": _vm.UAE_email,
      "subtitle": _vm.UAE,
      "title": "UAE",
      "height": "70vh"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns is-marginless is-paddingless is-gapless"
  }, [_c('div', {
    staticClass: "column is-5 m-b-10",
    class: {
      'm-r-10': _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)
    }
  }, [_c('card', {
    attrs: {
      "red": true,
      "background": _vm.USA_image,
      "isButtonHidden": true,
      "html": true,
      "email": _vm.USA_email,
      "subtitle": _vm.USA,
      "title": "USA",
      "height": "70vh"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-7 m-b-10"
  }, [_c('card', {
    attrs: {
      "red": true,
      "background": _vm.switzerland_image,
      "isButtonHidden": true,
      "html": true,
      "email": _vm.switzerland_email,
      "subtitle": _vm.switzerland,
      "title": "SWITZERLAND",
      "height": "70vh"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1147:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-header'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('v-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1148:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": "/fstatic/spinner.svg",
      "alt": ""
    }
  })])
}]}

/***/ }),

/***/ 1149:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "mobile-nav has-primary-background p-t-30 section"
  }, [_c('figure', {
    staticClass: "image relative"
  }, [(_vm.step1) ? _c('icon', {
    staticClass: "absolute is-white",
    staticStyle: {
      "left": "0px",
      "top": "7px"
    },
    attrs: {
      "name": "chevron-left",
      "scale": "1.6"
    },
    nativeOn: {
      "click": function($event) {
        _vm.step1 = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('icon', {
    staticClass: "absolute is-white",
    attrs: {
      "name": "close",
      "scale": "1.8"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('clicked')
      }
    }
  }), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "section m-t-25",
    class: {
      'is-hidden': _vm.step1
    }
  }, [_c('h1', {
    staticClass: "title is-3 is-white"
  }, [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "title is-3 is-white"
  }, [_c('router-link', {
    attrs: {
      "to": '/about'
    }
  }, [_vm._v("About Us")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "relative title is-3 is-white"
  }, [_vm._v("Capabilities "), _c('icon', {
    staticClass: "absolute is-white",
    attrs: {
      "name": "chevron-right",
      "scale": "1.5"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show('Capabilities')
      }
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "relative title is-3 is-white"
  }, [_vm._v("Solutions "), _c('icon', {
    staticClass: "absolute is-white",
    attrs: {
      "name": "chevron-right",
      "scale": "1.5"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show('Solutions')
      }
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "title is-3 is-white"
  }, [_c('router-link', {
    attrs: {
      "to": '/careers'
    }
  }, [_vm._v("Careers")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "title is-3 is-white"
  }, [_c('router-link', {
    attrs: {
      "to": '/contact'
    }
  }, [_vm._v("Contact")])], 1)]), _vm._v(" "), (_vm.step1 && _vm.isSolutionsVisible) ? _c('div', {
    staticClass: "solutions section m-t-25"
  }, [_c('solutions-dropdown', {
    attrs: {
      "solutions": _vm.solutions
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.step1 && _vm.isCapabilitiesVisible) ? _c('div', {
    staticClass: "section m-t-50",
    class: {
      'show': _vm.step1
    }
  }, [_vm._l((_vm.capabilities), function(capability) {
    return [_c('h1', {
      staticClass: "title is-4 is-white"
    }, [_c('router-link', {
      attrs: {
        "to": ("/capabilities/" + (capability.value))
      }
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": "/fstatic/spinner.svg"
      }
    }), _vm._v(_vm._s(capability.value) + " ")])], 1)]
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative width"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/fstatic/logo-text.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "absolute rotate",
    attrs: {
      "src": "/fstatic/spinner.svg",
      "alt": ""
    }
  })])
}]}

/***/ }),

/***/ 1150:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "wrapper relative"
  }, [_c('icon', {
    staticClass: "is-hoverable absolute",
    class: {
      gray: false
    },
    attrs: {
      "scale": "2.9",
      "name": "chevron-left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prev($event)
      }
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "is-hoverable absolute",
    class: {
      gray: false
    },
    attrs: {
      "scale": "2.9",
      "name": "chevron-right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.next($event)
      }
    }
  }), _vm._v(" "), (_vm.slides.length) ? _c('carousel', {
    ref: "carousel",
    attrs: {
      "adjustableHeight": true,
      "per-page": 1,
      "navigationSize": 1000,
      "navigationNextLabel": ">",
      "navigationPrevLabel": "<",
      "navigation-enabled": true,
      "navigationColor": 'white',
      "paginationEnabled": false,
      "paginationColor": 'black'
    }
  }, _vm._l((_vm.slides), function(slide) {
    return _c('slide', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('hero', {
      attrs: {
        "top": true,
        "backgroundImage": ("https://" + (_vm.baseURL()) + (slide.value.path))
      }
    })], 1)
  })) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('onClickaway', __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["directive"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('background', {
  inserted: function created(el, value) {
    var element = el;
    element.style.backgroundImage = 'url(' + value.value + ')';
    element.style.backgroundSize = 'cover';
    element.style.backgroundRepeat = 'none';
    element.style.backgroundPosition = 'center';
  }
});

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_carousel__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_media_query__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_media_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_media_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_axios__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_utils_hero__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_utils_hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_utils_hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_utils_card__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_utils_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_utils_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_utils_Thumb__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_utils_Thumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_utils_Thumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_utils_Loading__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_utils_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_utils_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_utils_breadcrumb__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_utils_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_utils_breadcrumb__);




// import VueAnalytics from 'vue-analytics';
// import * as VueGoogleMaps from 'vue2-google-maps';
// import VueI18n from 'vue-i18n';
// import VueScrollTo from 'vue-scrollto';
// import router from '../router';



// import 'buefy/dist/buefy.css'; // remove me
// import Buefy from 'buefy';
// import VeeValidate from 'vee-validate';
// import { VueAuthenticate } from 'vue-authenticate';






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("hero", __WEBPACK_IMPORTED_MODULE_7__components_utils_hero___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("card", __WEBPACK_IMPORTED_MODULE_8__components_utils_card___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("Thumb", __WEBPACK_IMPORTED_MODULE_9__components_utils_Thumb___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("Loading", __WEBPACK_IMPORTED_MODULE_10__components_utils_Loading___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("breadCrumb", __WEBPACK_IMPORTED_MODULE_11__components_utils_breadcrumb___default.a);

// Vue.use(VeeValidate);
// Vue.use(Buefy);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_5_axios___default.a);
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyBvWE_sIwKbWkiuJQOf8gSk9qzpO96fhfY',
//     libraries: 'places',
//   },
// });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_v_media_query___default.a, {
  variables: {
    tablet: "770px",
    miniLaptop: "990px"
  }
});
// Vue.use(VueAnalytics, {
//   id: 'UA-XXX-X',
//   router,
// });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_carousel___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("icon", __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon___default.a);
// Vue.use(VueI18n);
// Vue.use(VueScrollTo, {
//      container: "body",
//      duration: 800,
//      easing: "ease",
//      offset: -70,
//      cancelable: true,
//      onDone: false,
//      onCancel: false,
//      x: false,
//      y: true
//  });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  data: function data() {
    return {
      baseURL: function baseURL() {
        return "atd-cms.nbhood.com";
      }
    };
  }
});

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_pages_home__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_pages_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__layout_pages_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_pages_about__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_pages_about___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__layout_pages_about__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_pages_capabilities__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_pages_capabilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__layout_pages_capabilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_pages_contact__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_pages_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__layout_pages_contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_pages_solutions__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_pages_solutions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__layout_pages_solutions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__layout_pages_careers__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__layout_pages_careers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__layout_pages_careers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_utils_PageNotFound__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_utils_PageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_utils_PageNotFound__);












__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '*',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_10__components_utils_PageNotFound___default.a
    // meta: {
    //   title: 'Hi'
    // }
  }, {
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_4__layout_pages_home___default.a
    // meta: {
    //   title: 'Hi'
    // }
  }, {
    path: '/about',
    component: __WEBPACK_IMPORTED_MODULE_5__layout_pages_about___default.a
    // meta: {
    //   title: 'Hifds'
    // }
  }, {
    path: '/capabilities/:slug',
    name: 'capabilities',
    component: __WEBPACK_IMPORTED_MODULE_6__layout_pages_capabilities___default.a
    // meta: {
    //   title: 'Hi'
    // }
  }, {
    path: '/contact',
    component: __WEBPACK_IMPORTED_MODULE_7__layout_pages_contact___default.a,
    name: 'contact'
    // meta: {
    //   title: 'Hi'
    // }
  }, {
    path: '/solutions/:slug',
    name: 'solutions',
    component: __WEBPACK_IMPORTED_MODULE_8__layout_pages_solutions___default.a
    // meta: {
    //   title: 'Hi'
    // }
  }, {
    path: '/careers',
    component: __WEBPACK_IMPORTED_MODULE_9__layout_pages_careers___default.a
    // meta: {
    //   title: 'Hi'
    // }
  }]
});

// This callback runs before every route change, including on page load.
router.beforeEach(function (to, from, next) {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  var nearestWithTitle = to.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.title;
  });

  // Find the nearest route element with meta tags.
  var nearestWithMeta = to.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.metaTags;
  });
  var previousNearestWithMeta = from.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.metaTags;
  });

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(document.querySelectorAll('[data-vue-router-controlled]')).map(function (el) {
    return el.parentNode.removeChild(el);
  });

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(function (tagDef) {
    var tag = document.createElement('meta');

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tagDef).forEach(function (key) {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(function (tag) {
    return document.head.appendChild(tag);
  });

  next();
});

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(1135),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__(1157)
var prodEnv = __webpack_require__(65)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// see http://vuejs-templates.github.io/webpack for documentation.
var path = __webpack_require__(314)

module.exports = {
  build: {
    env: __webpack_require__(65),
    // apiUrl:'http://atd-cms.nbhood.com',
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'fstatic',
    assetsPublicPath: '/',
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: __webpack_require__.i({"NODE_ENV":"production"}).npm_config_report
  },
  dev: {
    env: __webpack_require__(121),
    // apiUrl:'http://realhub.nbhood.com/api',
    port: 8080,
    autoOpenBrowser: true,
    assetsSubDirectory: 'fstatic',
    assetsPublicPath: '/',
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_rest_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(71);




;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */]);

var entities = new __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api___default.a({
  axios: __WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* axiosInstance */],
  baseURL: __WEBPACK_IMPORTED_MODULE_3__api_axios__["baseURL"],
  state: {
    entities: []
  }
}).get({
  action: "listEntity",
  property: "entities",
  path: '/path/',
  queryParams: true
}).getStore();
/* harmony default export */ __webpack_exports__["a"] = (entities);

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_localstorage__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuex_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translations__ = __webpack_require__(64);



var state = {
    locale: 'en'
};
var getters = {
    locale: function getLocale(state) {
        return state.locale;
    }
};
var mutations = {
    setLocale: function setLocale(state, locale) {
        state.locale = locale;
        __WEBPACK_IMPORTED_MODULE_1__translations__["a" /* default */].locale = locale;
    }
};
var plugins = [__WEBPACK_IMPORTED_MODULE_0_vuex_localstorage___default()({
    namespace: 'namespace-for-state',
    initialState: {},
    expires: 7 * 24 * 60 * 60 * 1e3
})];

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    getters: getters,
    plugins: plugins
});

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  en: {
    utils: {
      locale: 'ar'
    },
    loading: {
      loading: 'Loading ..',
      error: 'Oops, something went wrong'
    },
    navbar: {
      home: 'Home'
    }
  },
  ar: {
    utils: {
      locale: 'en'
    },
    loading: {
      loading: 'جار التحميل ..',
      error: 'تبا شيء ما حدث بشكل خاطئ'
    }
  }
});

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_base__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layout_base__);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    baseLayout: __WEBPACK_IMPORTED_MODULE_0__layout_base___default.a
  }
});

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      solutions: "...",
      about: "...",
      capabilities: "...",
      contact: "...",
      careers: "...",
      about_image: "#",
      capabilities_image: "#",
      careers_image: "#",
      contact_image: "#",
      solutions_image: "#",
      loading: 0,
      loaded: 0,
      isLoading: false,
      capabilitiesInitialRoute: null,
      solutionsInitialRoute: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("capabilitiesInitialRoute", function (value) {
      _this.capabilitiesInitialRoute = value;
    });
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("solutionsInitialRoute", function (value) {
      _this.solutionsInitialRoute = value;
    });
  },
  created: function created() {
    var _this2 = this;

    this.axios.get("https://" + this.baseURL() + "/api/singletons/get/homepage?token=8864674b01000e6d7d030ef8c41e72").then(function (data) {
      // localStorage.setItem('about', JSON.stringify(data.data));
      // send the slider images in an event object
      console.log(_this2.bus);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("sliderImages", data.data["slider_images"]);
      _this2.solutions = data.data["solutions"];
      _this2.about = data.data["about"];
      _this2.capabilities = data.data["capabilities"];
      _this2.contact = data.data["contact"];
      _this2.careers = data.data["careers"];
      _this2.about_image = "https://" + _this2.baseURL() + data.data["about_image"]["path"];
      _this2.capabilities_image = "https://" + _this2.baseURL() + data.data["capabilities_image"]["path"];
      _this2.careers_image = "https://" + _this2.baseURL() + data.data["careers_image"]["path"];
      _this2.contact_image = "https://" + _this2.baseURL() + data.data["contact_image"]["path"];
      _this2.solutions_image = "https://" + _this2.baseURL() + data.data["solutions_image"]["path"];

      // subscribe to loading event to know how many images are loading
      _this2.$on("loading", function () {
        _this2.isLoading = true;
        _this2.loading++;
      });

      // detect when loading is finished
      _this2.$on("loaded", function () {
        _this2.loaded++;
        // working dynamically regardless of how many images are on page!
        if (_this2.loaded === _this2.loading) _this2.isLoading = false;
      });
    });
  }
});

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    var _this = this;

    // this.isLoading = true;
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("sliderImages", function (data) {
      _this.slides = data;
    });
  },
  data: function data() {
    return {
      slides: [],
      isLoading: false
    };
  },

  methods: {
    next: function next() {
      var carousel = this.$refs["carousel"];
      var currentPage = carousel.currentPage;
      var pageCount = carousel.pageCount;
      currentPage < pageCount - 1 ? carousel.goToPage(currentPage + 1) : carousel.goToPage(0);
    },
    prev: function prev() {
      var carousel = this.$refs["carousel"];
      var currentPage = carousel.currentPage;
      var pageCount = carousel.pageCount;
      currentPage != 0 ? carousel.goToPage(currentPage - 1) : carousel.goToPage(pageCount - 1);
    }
  }
});

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['route', 'itemsObj', 'solutions', 'capabilities', 'defaultRoute'],
  data: function data() {
    return {
      isActive: false
    };
  },

  methods: {
    Fn: function Fn() {
      this.isActive = true;
      this.revealDropdown();
    },
    revealDropdown: function revealDropdown(e) {
      // let rt = window.innerWidth - this.$refs.dropdown.getBoundingClientRect().right;
      // console.log('window: ' + window.innerWidth);
      // console.log('div: ' + this.$refs.dropdown.getBoundingClientRect().right);
      var overflow = this.$refs.dropdown.getBoundingClientRect().right - window.innerWidth;
      if (overflow > 0) {
        console.log('hi');
        this.$refs.dropdown.style.left = (overflow + 50) * -1 + 'px';
      }
      // overflow > 0 ?  : '';
      // console.log(overflow);
    }
  }
});

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isLoading: {
      default: true,
      type: Boolean
    }
  },
  created: function created() {
    if (this.isLoading) {
      document.getElementsByTagName('body')[0].classList.add('no-overflow');
    }
  },
  destroyed: function destroyed() {
    document.getElementsByTagName('body')[0].classList.remove('no-overflow');
  }
});

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    routeName: {
      type: String,
      required: true
    },
    subRoute: {
      type: String,
      required: false
    }
  }
});

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['background', 'top', 'height', 'title', 'subtitle', 'to', 'isButtonHidden', 'isButtonHiddenMobile', 'html', 'red', 'email'],
	data: function data() {
		return {
			isHovered: false,
			isClicked: false
		};
	},

	watch: {
		'background': function background(path) {
			var _this = this;

			if (path !== '#') {
				var url = path;

				var loaded = false;
				var img = new Image();
				img.src = url;
				// publish the loading event as a start
				this.$parent.$emit('loading');
				img.onload = function () {
					_this.$parent.$emit('loaded');
					loaded = true;
				};
				// if images not loaded after too long, just fire the event regardless 
				setTimeout(function () {
					if (!loaded) {
						_this.$parent.$emit('loaded');
					}
				}, 5000);
			}
		}
	},
	mounted: function mounted() {},

	methods: {
		hovered: function hovered(value) {
			// if (this.$route.name !== 'contact') {
			this.isHovered = value;
			// }
		},
		route: function route(to) {
			if (this.$route.name !== 'contact') {
				if (this.email) {
					document.location.href = 'mailto:' + this.email;
				}
				if (to) {
					this.$router.push('/' + to);
				}
			} else {
				this.isClicked = !this.isClicked;
			}
		}
	}
});

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['backgroundImage', 'direction', 'content', 'top'],
	watch: {
		'backgroundImage': function backgroundImage(path) {
			var _this = this;

			if (path !== '#') {
				var url = path;

				var loaded = false;
				var img = new Image();
				img.src = url;
				// publish the loading event as a start
				this.$parent.$emit('loading');
				img.onload = function () {
					_this.$parent.$emit('loaded');
					loaded = true;
				};
				// if images not loaded after too long, just fire the event regardless 
				setTimeout(function () {
					if (!loaded) {
						_this.$parent.$emit('loaded');
					}
				}, 5000);
			}
		}
	}
});

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_solutionsDropdown__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_solutionsDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_utils_solutionsDropdown__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    solutionsDropdown: __WEBPACK_IMPORTED_MODULE_0__components_utils_solutionsDropdown___default.a
  },
  props: {
    capabilities: {
      type: Array,
      required: true
    },
    solutions: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      isCapabilitiesVisible: false,
      isSolutionsVisible: false,
      step1: false
    };
  },

  methods: {
    show: function show(name) {
      this.isCapabilitiesVisible = false;
      this.isSolutionsVisible = false;
      this.step1 = true;
      this.$data['is' + name + 'Visible'] = true;
    }
  },
  created: function created() {
    document.getElementsByTagName('body')[0].classList.add('no-overflow');
  },
  destroyed: function destroyed() {
    document.getElementsByTagName('body')[0].classList.remove('no-overflow');
  }
});

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    created: function created() {
        console.log(this.solutions);
        var array = this.solutions.slice();
        array.filter(function (e) {
            return e.field.label === 'Category';
        });
        // know the indexes of `category`
        var indeces = [];
        array.map(function (e) {
            return e.field.label === 'Category' ? indeces.push(array.indexOf(e)) : null;
        });
        // cut array from one index till next index
        for (var i = 0; i < indeces.length; i++) {
            this.result.push(array.slice(indeces[i], indeces[i + 1]));
        }
        console.log(this.result);
    },

    methods: {
        toggle: function toggle(number) {
            this.expand = true;
            this.current = number;
        }
    },
    data: function data() {
        return {
            result: [],
            expand: false,
            current: null
        };
    },

    props: {
        solutions: {
            type: Array,
            required: true
        }
    }
});

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_header__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layout_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_footer__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__layout_footer__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VHeader: __WEBPACK_IMPORTED_MODULE_0__layout_header___default.a,
    VFooter: __WEBPACK_IMPORTED_MODULE_1__layout_footer___default.a
  }
});

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_Dropdown__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_utils_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_mobileNavbar__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_mobileNavbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils_mobileNavbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// http://atd-cms.nbhood.com/api/collections/get/capabilities?token=8864674b01000e6d7d030ef8c41e72&populate=1&filter[capability_category]=catB
//collections/get/Case?token=mytoken&filter[_id]=myentryid

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_0__components_utils_Dropdown___default.a,
    mobileNavbar: __WEBPACK_IMPORTED_MODULE_1__components_utils_mobileNavbar___default.a
  },
  created: function created() {
    var _this = this;

    // loop over capabilities categories
    this.axios.get("https://" + this.baseURL() + "/api/singletons/get/capabilities_categories?token=8864674b01000e6d7d030ef8c41e72").then(function (data) {
      _this.capabilities = data.data.categories;
      _this.capabilitiesInitialRoute = _this.capabilities[0].value;
      __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("capabilitiesInitialRoute", _this.capabilitiesInitialRoute);
    });
    // loop over solutions categories
    this.axios.get("https://" + this.baseURL() + "/api/singletons/get/solutions_categories?token=8864674b01000e6d7d030ef8c41e72").then(function (data) {
      var array = data.data.Categories;
      _this.allSolutions = data.data.Categories;
      array.filter(function (e) {
        return e.field.label === "Category";
      });
      // know the indexes of `category`
      var indeces = [];
      array.map(function (e) {
        return e.field.label === "Category" ? indeces.push(array.indexOf(e)) : null;
      });
      // cut array from one index till next index
      for (var i = 0; i < indeces.length; i++) {
        _this.solutions.push(array.slice(indeces[i], indeces[i + 1]));
      }
      _this.solutionsInitialRoute = _this.solutions[0][1].value;
      __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("solutionsInitialRoute", _this.solutionsInitialRoute);
    });
  },
  data: function data() {
    return {
      isActive: false,
      menuIsActive: false,
      solutions: [],
      capabilities: [],
      allSolutions: []
    };
  },

  watch: {
    $route: function $route(to, from) {
      this.menuIsActive = false;
      if (this.capabilitiesInitialRoute) __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("capabilitiesInitialRoute", this.capabilitiesInitialRoute);
      if (this.solutionsInitialRoute) __WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("solutionsInitialRoute", this.solutionsInitialRoute);
    },

    "$mq.resize": function $mqResize(argument) {
      if (argument > 1022) {
        this.menuIsActive = false;
      }
    }
  },
  methods: {}
});

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      letter: " ",
      letter_label: " ",
      letter_signature: " ",
      middle_image: "#",
      mission: " ",
      mission_label: " ",
      our_customers: " ",
      our_services: " ",
      our_services_label: " ",
      slide_image: "#",
      slide_label: " ",
      customers: [],
      loading: 0,
      loaded: 0,
      isLoading: false
    };
  },

  methods: {
    next: function next() {
      var carousel = this.$refs["carousel"];
      var currentPage = carousel.currentPage;
      var pageCount = carousel.pageCount;
      // currentPage , pageCount
      // if (this.$refs.carousel.currentPage < ( this.$refs.carousel.pageCount - 1) ) {
      currentPage < pageCount - 1 ? carousel.goToPage(currentPage + 1) : carousel.goToPage(0);
      // }
    },
    prev: function prev() {
      var carousel = this.$refs["carousel"];
      var currentPage = carousel.currentPage;
      var pageCount = carousel.pageCount;
      // currentPage , pageCount
      // if (this.$refs.carousel.currentPage > 0) {
      currentPage != 0 ? carousel.goToPage(currentPage - 1) : carousel.goToPage(pageCount - 1);
      // }
    }
  },
  mounted: function mounted() {
    // this.$refs.carousel.currentPage - 1;
  },
  created: function created() {
    var _this = this;

    this.axios.get("https://" + this.baseURL() + "/api/singletons/get/about?token=8864674b01000e6d7d030ef8c41e72").then(function (data) {
      // localStorage.setItem('about', JSON.stringify(data.data));
      _this.letter = data.data["letter"];
      _this.letter_label = data.data["letter_label"];
      _this.letter_signature = data.data["letter_signature"];
      _this.middle_image = "url(https://" + _this.baseURL() + data.data["middle_image"]["path"] + ")";
      _this.mission = data.data["mission"];
      _this.mission_label = data.data["mission_label"];
      _this.our_customers = data.data["our_customers"];
      _this.customers = data.data["customers"];
      _this.our_services = data.data["our_services"];
      _this.our_services_label = data.data["our_services_label"];
      _this.slide_image = "https://" + _this.baseURL() + data.data["slide_image"]["path"];
      _this.slide_label = data.data["slide_label"];
      // subscribe to loading event to know how many images are loading
      _this.$on("loading", function () {
        _this.isLoading = true;
        _this.loading++;
      });

      // detect when loading is finished
      _this.$on("loaded", function () {
        _this.loaded++;
        // working dynamically regardless of how many images are on page!
        if (_this.loaded === _this.loading) _this.isLoading = false;
      });
    });
  }
});

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      slider_image: "#",
      slider_label: "...",
      solutions: "...",
      header: "...",
      bullet_points: "...",
      careers: "...",
      isLoading: false,
      loading: 0,
      loaded: 0,
      related: [],
      capability_name: "..."
    };
  },

  watch: {
    $route: function $route() {
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      // match the current path and get the matching capability
      this.axios.get("https://" + this.baseURL() + "/api/collections/get/capabilities?token=8864674b01000e6d7d030ef8c41e72&populate=1&filter[capability_name]=" + this.$route.params.slug).then(function (data) {
        if (data.data.entries.length === 0) {
          // display error component
          // alert('error')
          _this.isLoading = false;
        }
        _this.slider_image = "https://" + _this.baseURL() + data.data.entries[0]["slider_image"]["path"];
        _this.slider_label = data.data.entries[0]["slider_text"];
        _this.header = data.data.entries[0]["header"];
        _this.bullet_points = data.data.entries[0]["bullet_points"];
        _this.careers = data.data.entries[0]["careers"];
        _this.capability_name = data.data.entries[0]["capability_name"];
      });
      // loop over all capabilites BUT the one in the slug
      this.axios.get("https://" + this.baseURL() + "/api/collections/get/capabilities?token=8864674b01000e6d7d030ef8c41e72&populate=1&filter[capability_name][$not]=" + this.$route.params.slug + "&fields[slider_image]=1&fields[slider_text]=1&fields[capability_name]=1&limit=3").then(function (data) {
        console.log(data.data.entries);
        _this.related = data.data.entries;
      });
    }
  },
  created: function created() {
    this.fetchData();
  },
  mounted: function mounted() {
    var _this2 = this;

    // subscribe to loading event to know how many images are loading
    this.$on("loading", function () {
      _this2.isLoading = true;
      _this2.loading++;
    });

    // detect when loading is finished
    this.$on("loaded", function () {
      _this2.loaded++;
      // working dynamically regardless of how many images are on page!
      if (_this2.loaded === _this2.loading) _this2.isLoading = false;
    });
  }
});

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    var _this = this;

    this.axios.get("https://" + this.baseURL() + "/api/singletons/get/careers?token=8864674b01000e6d7d030ef8c41e72").then(function (data) {
      console.log(data.data);
      _this.description = data.data["descriptn"];
      _this.careers = data.data["careers"];
      _this.slider_text = data.data["slider_text"];
      _this.slide_image = "https://" + _this.baseURL() + data.data["slider_image"]["path"];
      // subscribe to loading event to know how many images are loading
      _this.$on("loading", function () {
        _this.isLoading = true;
        _this.loading++;
      });

      // detect when loading is finished
      _this.$on("loaded", function () {
        _this.loaded++;
        // working dynamically regardless of how many images are on page!
        if (_this.loaded === _this.loading) _this.isLoading = false;
      });
    });
  },
  data: function data() {
    return {
      description: " ",
      slide_image: "#",
      careers: " ",
      slider_text: " ",
      loading: 0,
      loaded: 0,
      isLoading: false
    };
  }
});

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      switzerland: "...",
      switzerland_image: "#",
      switzerland_email: "...",
      USA: "...",
      USA_email: "...",
      USA_image: "#",
      UAE: "...",
      UAE_image: "#",
      UAE_email: "...",
      egypt: "...",
      egypt_email: "...",
      egypt_image: "#",
      isLoading: false,
      loading: 0,
      loaded: 0
    };
  },
  created: function created() {
    var _this = this;

    this.isLoading = true;
    this.axios.get("https://" + this.baseURL() + "/api/singletons/get/contact?token=8864674b01000e6d7d030ef8c41e72").then(function (data) {
      console.log(data.data);
      _this.switzerland = data.data["switzerland"];
      _this.switzerland_email = data.data["switzerland_email"];
      _this.USA = data.data["usa"];
      _this.USA_email = data.data["usa_email"];
      _this.UAE = data.data["uae"];
      _this.UAE_email = data.data["uae_email"];
      _this.egypt = data.data["egypt"];
      _this.egypt_email = data.data["egypt_email"];
      _this.switzerland_image = "https://" + _this.baseURL() + data.data["switzerland_image"]["path"];
      _this.USA_image = "https://" + _this.baseURL() + data.data["usa_image"]["path"];
      _this.UAE_image = "https://" + _this.baseURL() + data.data["uae_image"]["path"];
      _this.egypt_image = "https://" + _this.baseURL() + data.data["egypt_image"]["path"];

      // subscribe to loading event to know how many images are loading
      _this.$on("loading", function () {
        _this.loading++;
      });

      // detect when loading is finished
      _this.$on("loaded", function () {
        _this.loaded++;
        // working dynamically regardless of how many images are on page!
        if (_this.loaded === _this.loading) _this.isLoading = false;
      });
    });
  }
});

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_homepage_landing__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_homepage_landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_homepage_landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_homepage_homeCards__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_homepage_homeCards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_homepage_homeCards__);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Landing: __WEBPACK_IMPORTED_MODULE_0__components_homepage_landing___default.a,
    HomeCards: __WEBPACK_IMPORTED_MODULE_1__components_homepage_homeCards___default.a
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      slide_image: "#",
      slide_label: " ",
      solutions: " ",
      solution_description: " ",
      case_study_pdf: " ",
      case_study: null,
      isLoading: false,
      loading: 0,
      loaded: 0,
      related: [],
      solution_name: " "
    };
  },

  watch: {
    $route: function $route() {
      this.fetchData();
    }
  },
  mounted: function mounted() {
    var _this = this;

    // subscribe to loading event to know how many images are loading
    this.$on("loading", function () {
      _this.isLoading = true;
      _this.loading++;
    });

    // detect when loading is finished
    this.$on("loaded", function () {
      _this.loaded++;
      // working dynamically regardless of how many images are on page!
      if (_this.loaded === _this.loading) _this.isLoading = false;
    });
  },

  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      // match the current parameter and get the matching capability
      this.axios.get("https://" + this.baseURL() + "/api/collections/get/solutiona?token=8864674b01000e6d7d030ef8c41e72&populate=1&filter[solution_name]=" + this.$route.params.slug).then(function (data) {
        if (data.data.entries.length === 0) {
          // display error component
          alert("error!");
          _this2.isLoading = false;
        }
        // localStorage.setItem('about', JSON.stringify(data.data));
        _this2.slide_image = "https://" + _this2.baseURL() + data.data.entries[0]["slide_image"]["path"];
        _this2.slide_label = data.data.entries[0]["slide_label"];
        _this2.solution_description = data.data.entries[0]["solution_description"];
        _this2.case_study_pdf = data.data.entries[0]["case_study_pdf"];
        _this2.case_study = data.data.entries[0]["case_study"];
        _this2.solution_name = data.data.entries[0]["solution_name"];
      });
      // loop over all solutions BUT the one in the slug
      this.axios.get("https://" + this.baseURL() + "/api/collections/get/solutiona?token=8864674b01000e6d7d030ef8c41e72&populate=1&filter[solution_name][$not]=" + this.$route.params.slug + "&fields[slide_image]=1&fields[slide_label]=1&fields[solution_name]=1&limit=3").then(function (data) {
        console.log(data.data);
        _this2.related = data.data.entries;
      });
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bus", function() { return bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__translations__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(63);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* router */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_5__translations__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_translation__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_consumeRest__ = __webpack_require__(140);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    translation: __WEBPACK_IMPORTED_MODULE_2__modules_translation__["a" /* default */],
    consumeRest: __WEBPACK_IMPORTED_MODULE_3__modules_consumeRest__["a" /* default */]
  }
}));

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_i18n__ = __webpack_require__(1108);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]({
  locale: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.locale, // set locale
  messages: __WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */] // set locale messages
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),

/***/ 65:
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return axiosInstance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config__);




var axiosInstance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();
axiosInstance.interceptors.request.use(function (config) {
    config.headers = { 'Accept-Language': axiosInstance.lang };
    return config;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});
// export const baseURL = process.env.NODE_ENV === 'production'
//   ? config.build.apiUrl
//   : config.dev.apiUrl;



/***/ })

},[21]);


// WEBPACK FOOTER //
// fstatic/js/app.c8cb779fe8af451b08e0.js